import { useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import ObjectUtils from '../../../../utils/ObjectUtils';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './ClearLessonSelectionAction.scss';

const selectedNumberClass = 'selected-number-highlighted';

const defaultProps = {
  selectedLessonIds: [],
  onClearClick: () => {},
  className: '',
  clearSelectedLessonTitle: 'Deselect activities',
};

const ClearLessonAction = (p) => {
  const { selectedLessonIds, onClearClick, className, clearSelectedLessonTitle } = { ...defaultProps, ...filterUndefined(p) };
  const selectedNumberRef = useRef(null);
  useEffect(() => {
    if (selectedLessonIds.length > 0 && selectedNumberRef.current) {
      selectedNumberRef.current.classList.add(selectedNumberClass);
      ObjectUtils.setTimeout(() => {
        if (selectedNumberRef.current) {
          selectedNumberRef.current.classList.remove(selectedNumberClass);
        }
      }, 1000);
    }
  }, [selectedLessonIds.length]);

  return (
    selectedLessonIds.length > 0 && (
      <div className={`clear-lesson-selection ${className}`}>
        <div className='number-of-selected-lessons'>
          <div className='selected-number' ref={selectedNumberRef}>
            {selectedLessonIds.length}
          </div>
          {selectedLessonIds.length > 1 ? 'Activities' : 'Activity'}&nbsp;
          selected
        </div>
        <Button tabIndex={0} onClick={onClearClick} className='clear-selected-lessons' data-test='clear-selected-lessons'>
          {clearSelectedLessonTitle}
        </Button>
      </div>
    )
  );
};

export default ClearLessonAction;
